<template>
  <div class="page-template" v-loading="loading">
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="商品毛利明细" name="goodsProfit">
        <search-form-template
          :searchOptions="goodsProfitSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(1)"
        ></search-form-template>
        <table-template
          ref="goodsProfit"
          :tableOptions="wholesaleGoodsProfitTable">
        </table-template>
      </el-tab-pane>
      <el-tab-pane label="批发单据毛利" name="orderProfit">
        <search-form-template
          :searchOptions="orderProfitSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(2)"
        ></search-form-template>
        <table-template
          ref="orderProfit"
          :tableOptions="wholesaleOrderProfitTable"></table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import searchFormTemplate from '@/components/template/searchFormTemplate';
  import tableTemplate from '@/components/template/tableTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower';

  export default {
    mixins: [userPower],
    name: 'RoleManager',
    components: {
      tableTemplate,
      searchFormTemplate
    },
    data() {
      return {
        activeTab: 'goodsProfit',
        loading: false,
        treeConfig: {
          id: 'menuTree',
          showCheckbox: true,
          data: [],
          nodeKey: 'id',
          defaultProps: {
            children: 'children',
            label: 'name'
          },
          request: {
            api: api.system.rolePrivilege,
            param: {roleId: ''}
          }
        },
        // 批发商品汇总高级查询
        goodsProfitSearchOptions: {
          simple: [
            {
              label: '',
              prop: 'otherName',
              type: 'input',
              span: 6,
              isFuzzy: true,
              placeholder: '请输入商品名称/条码'
            }

          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              span: 6,
              isHasAll: true,
              url: api.system.seStore,
              change: this.getBrandSupplier
            },
            {
              label: '品牌',
              type: 'select',
              prop: 'goodsBrandId',
              data: [],
              span: 6
            },
            {
              label: '供应商',
              type: 'select',
              prop: 'supplierId',
              data: [],
              span: 6
            },
            {
              label: '类别',
              type: 'cascaderMultiple',
              prop: 'goodsCategoryIds',
              valueKey: 'value',
              data: [],
              span: 6,
              change: this.typeChange,
              url: api.archives.getCategoryTree
            },
          ]
        },
        // 批发单据汇总高级查询
        orderProfitSearchOptions: {
          simple: [
            {
              label: '请输入业务单号',
              prop: 'wholesaleOrderNo',
              type: 'input',
              ifFuzzy: true,
              placeholder: '请输入业务单号'
            }
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              span: 8,
              isHasAll: true,
              url: api.system.seStore
            },
            {
              label: '客户名称',
              prop: 'wholesaleCustomerId',
              type: 'select',
              span: 8,
              data: [],
              url: api.wholesale.archives
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '打印',
            code: 'print'
          },
          {
            label: '导出',
            code: 'export',
            callback: this.exportExcel
          }
        ],
        // 批发商品汇总
        wholesaleGoodsProfitTable: {
          showSummary: true,
          summaryColumns: ['goodsCount', 'discountAmt', 'purchaseMoney', 'profitMoney'],
          indexShow: true, // 是否显示索引
          indexMethod: (index) => { // 自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店',
              prop: 'storeName',
              width: '120',
              align: 'center'
            },
            {
              label: '单号',
              prop: 'wholesaleOrderNo',
              width: '220',
              align: 'center',
              callback: this.goOrderDetail
            },
            {
              label: '条码',
              prop: 'barCode',
              width: '150',
              align: 'center'
            },
            {
              label: '品名',
              prop: 'goodsName',
              width: '300',
              align: 'center'
            },
            {
              label: '自编码',
              prop: 'artNo',
              width: '120',
              align: 'center'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '120',
              align: 'center'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '120',
              align: 'center'
            },
            {
              label: '销售数量',
              prop: 'goodsCount',
              width: '120',
              align: 'center'
            },
            {
              label: '销售金额',
              prop: 'discountAmt',
              width: '120',
              align: 'center'
            },
            {
              label: '成本金额',
              prop: 'purchaseMoney',
              width: '120',
              align: 'center'
            },
            {
              label: '毛利',
              prop: 'profitMoney',
              width: '120',
              align: 'center'
            },
            {
              label: '毛利率',
              prop: 'profitRate',
              width: '120',
              align: 'center'
            },
            {
              label: '类别',
              prop: 'goodsCategoryName',
              width: '190',
              align: 'center'
            },
            {
              label: '品牌',
              prop: 'goodsBrandName',
              width: '150',
              align: 'center'
            },
            {
              label: '供应商名称',
              prop: 'supplierName',
              width: '150',
              align: 'center'
            },
          ],
          url: api.wholesale.goodsProfit
        },
        // 批发单据汇总
        wholesaleOrderProfitTable: {
          showSummary: true,
          summaryColumns: ['goodsCount', 'discountAmt', 'purchaseMoney', 'profitMoney'],
          indexShow: true, // 是否显示索引
          indexMethod: (index) => { // 自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店',
              prop: 'storeName',
              width: '140',
              align: 'center',
            },
            {
              label: '单号',
              prop: 'wholesaleOrderNo',
              width: '140',
              align: 'center',
              callback: this.goOrderDetail
            },
            {
              label: '客户',
              prop: 'wholesaleCustomerName',
              width: '140',
              align: 'center'
            },
            {
              label: '销售数量',
              prop: 'goodsCount',
              width: '120',
              align: 'center'
            },
            {
              label: '销售金额',
              prop: 'discountAmt',
              width: '120',
              align: 'center'
            },
            {
              label: '成本金额',
              prop: 'purchaseMoney',
              width: '120',
              align: 'center'
            },
            {
              label: '毛利',
              prop: 'profitMoney',
              width: '120',
              align: 'center'
            },
            {
              label: '毛利率',
              prop: 'profitRate',
              width: '120',
              align: 'center'
            },
          ],
          url: api.wholesale.orderProfit
        },
        salesDetailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '100px',
            top: '0',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
            },
            {
              label: "批发门店",
              prop: "storeName",
            },
            {
              label: '批发客户',
              prop: 'wholesaleCustomerName',
            }, {
              label: '仓库',
              prop: 'warehouseName',
            }, {
              label: '经手人',
              prop: 'salesman',
            }, {
              label: '备注',
              prop: 'remarks',
            }],
          tablesProp: {
            wlWholesaleOrderGoodsMapList: {
              url: api.wholesale.wholesaleQuery + "/page",
              height: this.detailHeight,
              indexShow: true,
              showSummary: true,
              summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
              tableName: "wlWholesaleOrderGoodsMapList",
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '125',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsCount',
                  align: "center"
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsCount',
                  align: "center"
                },
                {
                  label: '原价',
                  width: '90',
                  prop: 'beforePrince',
                  align: "center"
                },
                {
                  label: '原价金额',
                  width: '90',
                  prop: 'beforeAmt',
                  align: "center"
                },
                {
                  label: '折扣',
                  width: '90',
                  prop: 'discountRate',
                  align: "center"
                },
                {
                  label: '折扣价格',
                  width: '90',
                  prop: 'discountPrince',
                  align: "center"
                },
                {
                  label: '小计金额',
                  width: '90',
                  prop: 'discountAmt',
                  align: "center"
                },
                {
                  label: '系统库存',
                  width: '90',
                  prop: 'inventoryNum',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            }
          },

          // 打印的列表
          printTablesProp: {
            wlWholesaleOrderGoodsMapList: {
              tableName: 'wlWholesaleOrderGoodsMapList',
              showSummary: true,
              summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
              columns: [
                {
                  label: '序号',
                  prop: 'indexShow',
                  width: '50',
                  align: "center"
                },
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '125',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsCount',
                  align: "center"
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsCount',
                  align: "center"
                },
                {
                  label: '原价',
                  width: '90',
                  prop: 'beforePrince',
                  align: "center"
                },
                {
                  label: '原价金额',
                  width: '90',
                  prop: 'beforeAmt',
                  align: "center"
                },
                {
                  label: '折扣',
                  width: '90',
                  prop: 'discountRate',
                  align: "center"
                },
                {
                  label: '折扣价格',
                  width: '90',
                  prop: 'discountPrince',
                  align: "center"
                },
                {
                  label: '小计金额',
                  width: '90',
                  prop: 'discountAmt',
                  align: "center"
                },
                {
                  label: '系统库存',
                  width: '90',
                  prop: 'inventoryNum',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            },
          },
          url: api.wholesale.wholesaleSales
        },
        returnDetailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '100px',
            top: '0',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
            },
            {
              label: "批发门店",
              prop: "storeName",
            }, {
              label: '批发客户',
              prop: 'wholesaleCustomerName',
            }, {
              label: "仓库",
              prop: "warehouseName",
            }, {
              label: '经手人',
              prop: 'salesman',
            },
            {
              label: '批发销售单',
              type: 'select',
              prop: 'wholesaleOrderNo',
            }, {
              label: '备注',
              prop: 'remarks',
            }],
          tablesProp: {
            wlWholesaleOrderGoodsMapList: {
              url: api.wholesale.wholesaleQuery + "/page",
              height: this.detailHeight,
              indexShow: true,
              showSummary: true,
              tableName: "wlWholesaleOrderGoodsMapList",
              summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '125',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsCount',
                  type: 'inputNumber',
                  align: "center"
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsCount',
                  align: "center"
                },
                {
                  label: '原价',
                  width: '90',
                  prop: 'beforePrince',
                  align: "center"
                },
                {
                  label: '原价金额',
                  width: '90',
                  prop: 'beforeAmt',
                  align: "center"
                },
                {
                  label: '折扣',
                  width: '90',
                  prop: 'discountRate',
                  align: "center"
                },
                {
                  label: '折扣价格',
                  width: '90',
                  prop: 'discountPrince',
                  align: "center"
                },
                {
                  label: '小计金额',
                  width: '90',
                  prop: 'discountAmt',
                  align: "center"
                },
                {
                  label: '系统库存',
                  width: '90',
                  prop: 'inventoryNum',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            }
          },

          // 打印的列表
          printTablesProp: {
            wlWholesaleOrderGoodsMapList: {
              tableName: 'wlWholesaleOrderGoodsMapList',
              showSummary: true,
              summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '125',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsCount',
                  type: 'inputNumber',
                  align: "center"
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsCount',
                  align: "center"
                },
                {
                  label: '原价',
                  width: '90',
                  prop: 'beforePrince',
                  align: "center"
                },
                {
                  label: '原价金额',
                  width: '90',
                  prop: 'beforeAmt',
                  align: "center"
                },
                {
                  label: '折扣',
                  width: '90',
                  prop: 'discountRate',
                  align: "center"
                },
                {
                  label: '折扣价格',
                  width: '90',
                  prop: 'discountPrince',
                  align: "center"
                },
                {
                  label: '小计金额',
                  width: '90',
                  prop: 'discountAmt',
                  align: "center"
                },
                {
                  label: '系统库存',
                  width: '90',
                  prop: 'inventoryNum',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            },
          },
          url: api.wholesale.wholesaleReturn
        }
      };
    },
    created() {
      this.title = document.title;
      this.setStore(this.goodsProfitSearchOptions.complex);
      this.setStore(this.orderProfitSearchOptions.complex);
    },
    mounted() {
      this.getStoreBrandSup()
      this.getWarehouseId()
    },
    methods: {
      goOrderDetail(row) {
        console.log(row);
        if (row.wholesaleType === 50) {
          this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.salesDetailColumns);
          const {href} = this.$router.resolve({
            name: 'SalesDetail',
            query: {id: row.wholesaleOrderId}
          });
          window.open(href, '_blank');
        } else {
          this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.returnDetailColumns);
          const {href} = this.$router.resolve({
            name: 'wholeasleReturnDetail',
            query: {id: row.wholesaleOrderId}
          });
          window.open(href, '_blank');
        }
      },
      // 选择门店
      getWarehouseId() {
        let userInfo = this.$utils.getSysUser()
        let warehouseId = this.storeWholesaleSumSearchOptions.complex.filter(v => v.prop === 'warehouseId')[0]
        if (userInfo.storeId) {
          // 仓库数据
          this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: userInfo.storeId}).then(res => {
            if (res.code === 200 && res.data) {
              warehouseId.data = res.data
            }
          })
        }
      },
      tabChange() {
        this.$refs[this.activeTab].operationSuccess();
      },
      searchSubmit(param) {
        console.log(param)
        this.$refs[this.activeTab].searchParam = param;
        this.$refs[this.activeTab].operationSuccess();
      },
      clearSearch() {
        this.$refs['goodsProfit'].clearSearch();
        this.$refs['orderProfit'].clearSearch();
        let userInfo = this.$utils.getSysUser();
        if (!userInfo.storeId) {
          this.goodsProfitSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
          this.goodsProfitSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
          this.storeWholesaleSumSearchOptions.complex.filter(item => item.prop === 'warehouseId')[0].data = []
        }
      },
      getStoreBrandSup() {
        let userInfo = this.$utils.getSysUser();
        if (userInfo.storeId) {
          this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: userInfo.storeId}).then(data => {
            if (data.code === 200) {
              this.goodsProfitSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
            }
          });
          this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: userInfo.storeId}).then(data => {
            if (data.code === 200) {
              this.goodsProfitSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
            }
          })
        }
      },
      getBrandSupplier(form) {
        form.goodsBrandId = ''
        form.supplierId = ''
        this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.goodsProfitSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
          }
        });
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.goodsProfitSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
          }
        })
      },
      exportExcel(param) {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let params, url, fileName;
        if (param === 1) {
          params = this.$refs['goodsProfit'].searchParam;
          url = api.wholesale.goodsProfitExport;
          fileName = '商品毛利_' + this.$utils.getDateTime() + '.xls';
        } else if (param === 2) {
          params = this.$refs['orderProfit'].searchParam;
          url = api.wholesale.orderProfitExport;
          fileName = '单据毛利_' + this.$utils.getDateTime() + '.xls';
        }
        this.$axios.PostBlob(url, params).then(res => {
          if (res.status === 200) {
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            // this.$message.success("导出成功,文件名称:" + fileName);
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("当前导出数据为空或超出10000条");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      }
    }
  }
</script>

<style scoped>
  .page-template {
    padding-top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/page/wholeasle/Profit.vue